<ng-container *ngIf="state.dataTestType as dataTestType">
  <y42-data-test-type-with-icon [dataTestType]="dataTestType"></y42-data-test-type-with-icon>
</ng-container>
<span *ngIf="state.aggFuncValue as aggFuncValue">({{ aggFuncValue }})</span>
